/* eslint-disable max-lines */
import tw, { styled } from 'twin.macro';

const fontFamily = 'Circular Std';

export const FieldWrapper = styled.div`
  ${tw`my-4 relative`};
  @media (max-width: 576px) {
    display: block;
  }
`;

export const SubTextWrapper = styled.p`
  ${tw`italic mt-1 text-base text-gray-500`}
  font-family: ${fontFamily} !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-family: var(--formFontType) !important;
    color: var(--formBodyLabelColor, var(--formTextColor));
    font-size: var(--formFontSize);
  `}
  display: block;
`;

export const Field = styled.div`
  ${tw`m-0 clear-both`};
  :last-child {
    margin-bottom: 0;
  }

  @media (max-width: 576px) {
    display: block;
  }
`;

export const LabelWrapper = styled.label`
  ${tw`font-normal text-base text-blackened block my-0 mt-0 mb-1 normal-case `};

  font-family: ${fontFamily} !important;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-size: var(--formFontSize);
    font-family: var(--formFontType) !important;
    font-weight: 500;
  `}

  &:after {
    ${({ required }) =>
      required &&
      `
      content : '*';
      margin: -.2em 0 0 .2em;
      color: #db2828;
    `}
  }
`;

export const Table = styled.table`
  ${tw`my-4 mx-0 rounded text-left text-blackened border-separate text-base `}
  border: 1px solid rgba(34,36,38,.15);
  table-layout: fixed;

  width: ${({ customTableWidth, isPreviewMobile, unstackable, unstacked }) => {
    if (
      (!isPreviewMobile && customTableWidth && (unstacked || unstackable)) ||
      (isPreviewMobile && customTableWidth && unstackable)
    ) return `${customTableWidth}px`;
    return '100%';
  }};

  ${({ displayedRow, hasRowTitles, disableAddRow }) =>
    displayedRow &&
    !hasRowTitles && !disableAddRow &&
    `
    tr th:last-child {
      width: 70px;
    }
  `}

  ${({ noBorder }) =>
    noBorder &&
    `
    border: none;
    @media (min-width: 769px) {
      margin-left: -11px;
    }
  `}

  ${({ unstackable }) =>
    unstackable &&
    `
    tr, th, td {
      border: none;
    }
  `}
  
  &:first-of-type {
    margin-top: 0;
  }

  ${({ customTableWidth, isPreviewMobile, columnCount }) => {
    if (!customTableWidth && (isPreviewMobile || columnCount >= 5)) {
      return `table-layout: auto;`
    }
  }}

  @media (max-width: 767px) {
    width: ${({ customTableWidth, unstackable }) => {
      if (customTableWidth && unstackable) return `${customTableWidth}px`;
      return '100%'
    }};
  }
`;

export const InputWrapper = styled.input`
  ${tw`w-full m-0 outline-none p-2.5 text-base bg-white border border-solid rounded opacity-70 border-greyed `};
  :focus {
    border-color: #85b7d9;
  }
  ${({ formFieldBorderColor, formFieldBackgroundColor, formFontType }) =>
    (formFieldBorderColor || formFieldBackgroundColor || formFontType) &&
    `
    border-color: ${formFieldBorderColor};
    background: ${formFieldBackgroundColor};
    font-family: ${formFontType}!important;
  `};

  ${({ formFieldBorderRadius }) =>
    formFieldBorderRadius >= 0 &&
    `
    border-radius : ${formFieldBorderRadius}px;
  `}

  ${({ labelOrientation }) =>
    labelOrientation === 'side-by-side' &&
    `
      flex : 0 0 70%;
  `}
  ${(props) =>
    props.type === 'radio' &&
    `
    width: auto !important;
    opacity: 0 !important;
    display: none;
  `}
  ${({ left }) =>
    left &&
    `
    border-top-left-radius: 0;
   border-bottom-left-radius: 0;
  `}
  ${({ right }) =>
    right &&
    `
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  `}
  &.table-smiley {
    position: absolute;
  }
  @media (max-width: 576px) {
    width: 100%;
  }
`;

export const TableHeader = styled.thead`
  ${({ stacked, unstackable }) =>
    stacked &&
    unstackable &&
    `
    display: none;
    
  `}

  ${({ isPreviewMobile, unstackable }) => {
    if (isPreviewMobile && unstackable) {
      return `
      display: none;
      tr, th {
        width: auto;
        display: block;
      }`
    }
  }}

  & th {
    cursor: auto;
    background: 0 0;
    padding: 0.92857143em 0.78571429em;
    vertical-align: inherit;
    font-weight: 600;
    text-transform: none;
    border-bottom: 1px solid rgba(34, 36, 38, 0.1);
    transition: background 0.1s ease, color 0.1s ease;
    :first-of-type {
      border-left: none;
    }

    > div > div > span {
      font-weight: 400;
      font-family: ${fontFamily} !important;
      color: #777;
    }
  }

  ${({ noBorder }) =>
    noBorder &&
    `
    tr, th {
      border: none;
    }
  `}

  @media (max-width: 767px) {
    ${({ isPreviewMobile, unstackable }) => {
      if (isPreviewMobile || unstackable) {
        return `
        display: none;
        
        tr,
        th {
          width: auto;
          display: block;
        }`
      }
    }}
  }
`;

export const DeleteRowButton = styled.button`
  border: none;
  border-radius: 3px;
  padding: 10px;
  outline: none;
  cursor: pointer;
  width: 100%;
 
  &.no-cursor {
    cursor: not-allowed;
  }

  color: var(--btn-color, #000000);
  transition: 200ms;
  background-color: var(--btn-bg, whitesmoke);


  ${({ inForm }) =>
  inForm &&
    `
    background-color: var(--btn-bg, #e0e1e2);
    :hover {
      filter: brightness(0.85);
    }
  `}
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  td {
    padding: 0.78571429em 0.78571429em;
    background: 0 0;

    &.title {
      font-family: var(--formFontType, Circular Std) !important;
      color: var(--formBodyLabelColor, var(--formTextColor));
      opacity: 0.7;
    }
  }

  ${({ noBorder }) =>
    noBorder &&
    `
    & tr, td {
      border: none;
    }
  `}

  td::before {
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-size: var(--formFontSize);
    font-family: var(--formFontType, Circular Std) !important;
  }

  ${({ stacked }) =>
    stacked &&
    `
    tr, td {
      width: auto;
      display: block;
    }
  `}

  ${({ unstackable, isPreviewMobile }) => {
    if (isPreviewMobile && !unstackable) {
      return `
      tr, td {
        width: auto;
        display: block;
      }
      
      & tr {
        padding-top: 1em;
        padding-bottom: 1em;
        box-shadow: 0 -1px 0 0 rgba(0,0,0,.1) inset;
      }`
    }
  }}
  
  ${({ columnCount }) =>
    columnCount >= 5 &&
    `
    td {
      min-width: 250px;
      width: auto;
    }
    td.remove-icon {
      min-width: 50px;
    }
  `}

  td {
    &.remove-icon {
      min-width: 50px;
      text-align: center;
    }
  }

  ${({ inForm, unstackable }) => {
    if (inForm && !unstackable) {
      return `
      @media (max-width: 767px) {
        tr,
        td {
          width: auto;
          display: block;
        }
        
        & tr {
          padding-top: 1em;
          padding-bottom: 1em;
          box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1) inset;
        }
      }`
    }
  }}
`;

export const TableHeaderSpan = styled.span`
  font-family: ${fontFamily} !important;
  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-size: var(--formFontSize);
    font-family: var(--formFontType) !important;
  `};
  cursor: pointer;
  font-weight: 300;
  word-break: break-word;

  ${({ requiredStar }) =>
    requiredStar &&
    `
    ::after {
      display: inline-block;
      vertical-align: top;
      content: '*';
      color: #db2828;
      margin: -.2em 0 0 .2em;
    }
    `}
`;

export const FieldRenderer = styled.div`
  ${({ Noclick }) =>
    Noclick &&
    `
    pointer-events: none;
    cursor: pointer;
 `}
 
  .table-ctrl-label {
    ${tw`font-normal text-base text-blackened hidden my-0 mt-0 mb-1 normal-case `};
    font-family: ${fontFamily} !important;

    &.not-in-builder {
      color: var(--formBodyLabelColor, var(--formTextColor));
      font-family: var(--formFontType) !important;
      text-transform: var(--formLabelTransform);
      font-size: var(--formFontSize);
      word-wrap: break-word;
      font-weight: 500;
    }

    @media (max-width: 768px) {
      ${tw`inline-block`};
    }

    &.show {
      ${tw`inline-block`};
    }
    
    &:after {
      ${(props) =>
        props.requiredStar &&
        `
        margin: -.2em 0 0 .2em;
        color: #db2828;
        content : '*';
      `}
    }
  }
`;

export const AddRowButton = styled.button`
  ${tw`cursor-pointer inline-block min-h-4 outline-none align-baseline 
    text-center no-underline px-6 py-3 bg-transparent text-lightGray font-normal 
    normal-case rounded leading-4 border border-solid border-grayish-200
  `};

  border: ${({ hasCustomBackground }) => (hasCustomBackground ? '1px solid var(--btn-bg, #ffffff)' : '1px solid #21ba45')};
  background-color: var(--btn-bg, #ffffff);
  color: var(--btn-color, #21ba45);
  font-family: var(--btn-font, 'Inter') !important;

  :disabled {
    cursor: not-allowed;
  }
`;

export const TableSubWrapper = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c3c4cd;
  }
`;

export const AddColBtn = styled.button`
  padding: 10px;
  width: 40px;
  background-color: #e0e1e2;
  border-radius: 3px;
  border: none;
  cursor: pointer;

  &.no-cursor {
    cursor: not-allowed;
  }

  :hover {
    filter: brightness(0.85);
  }
`;

export const ColBtn = styled.button`
  background: transparent;
  cursor: pointer;
  border: none;
  border-radius: 3px;

  &:hover,
  &:focus {
    border: none;
    background-color: #eee;
  }
`;

export const TableFoot = styled.tfoot`
  td {
    padding: 5px 11px;

    > span {
      font-family: var(--formFontType, Circular Std) !important;
      color: var(--formBodyLabelColor, var(--formTextColor));
      opacity: 0.7;
    }
  }
  ${({ stacked }) =>
    stacked &&
    `
    tr {
      text-align: center;
    }
    tr, td {
      width: auto;
      display: block;
    }
  `}

  ${({ isPreviewMobile }) =>
    isPreviewMobile &&
    `
      tr {
        text-align: center;
      }
      tr, td {
        width: auto;
        display: block;
      }
  `}

  @media (max-width: 767px) {
    tr {
      text-align: center;
    }
    tr,
    td {
      width: auto;
      display: block;
    }
  }
`;

export default {
  FieldWrapper,
  Field,
  LabelWrapper,
  SubTextWrapper,
  Table,
  InputWrapper,
  TableHeader,
  TableBody,
  TableHeaderSpan,
  FieldRenderer,
  AddRowButton,
  AddColBtn,
  TableSubWrapper,
};
